import React from 'react';
import Navbar from '@/components/Navbar';

const galleryImages = [
  'https://images.unsplash.com/flagged/photo-1567934150921-7632371abb32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMHBhaW50aW5nfGVufDB8fHx8MTc2MTI0ODQwMnww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1531056416665-266c4099c928?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMHBhaW50aW5nfGVufDB8fHx8MTc2MTI0ODQwMnww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1533208087231-c3618eab623c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMHBhaW50aW5nfGVufDB8fHx8MTc2MTI0ODQwMnww&ixlib=rb-4.1.0&q=85',
  'https://images.unsplash.com/photo-1531489956451-20957fab52f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMHBhaW50aW5nfGVufDB8fHx8MTc2MTI0ODQwMnww&ixlib=rb-4.1.0&q=85',
  'https://images.pexels.com/photos/1269968/pexels-photo-1269968.jpeg',
  'https://images.pexels.com/photos/1573434/pexels-photo-1573434.jpeg',
  'https://images.pexels.com/photos/34387668/pexels-photo-34387668.jpeg',
  'https://images.pexels.com/photos/10391201/pexels-photo-10391201.jpeg'
];

const Gallery = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-5xl font-bold text-center mb-4 bg-gradient-to-r from-teal-500 to-pink-500 bg-clip-text text-transparent">
          Gallery
        </h1>
        <p className="text-center text-gray-600 mb-12">A showcase of our finest work</p>
        
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="gallery-grid">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="group relative aspect-square overflow-hidden rounded-lg cursor-pointer"
              data-testid={`gallery-item-${index}`}
            >
              <img 
                src={image}
                alt={`Gallery ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <span className="text-white font-semibold">View Details</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;